import { render, staticRenderFns } from "./CommonTable.vue?vue&type=template&id=04a46e8c"
import script from "./CommonTable.vue?vue&type=script&lang=js"
export * from "./CommonTable.vue?vue&type=script&lang=js"
import style0 from "./CommonTable.vue?vue&type=style&index=0&id=04a46e8c&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04a46e8c')) {
      api.createRecord('04a46e8c', component.options)
    } else {
      api.reload('04a46e8c', component.options)
    }
    module.hot.accept("./CommonTable.vue?vue&type=template&id=04a46e8c", function () {
      api.rerender('04a46e8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/LabelGroup/components/CommonTable.vue"
export default component.exports